import { render } from "./ByFolder.vue?vue&type=template&id=1330ffa1&scoped=true"
import script from "./ByFolder.vue?vue&type=script&lang=js"
export * from "./ByFolder.vue?vue&type=script&lang=js"

import "./ByFolder.vue?vue&type=style&index=0&id=1330ffa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1330ffa1"]])

export default __exports__